module.exports = __webpack_public_path__ + "static/img/weixin.9c68e9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weixin.png
// module id = 33
// module chunks = 0 1 2 3 4 5 6 7 8 10 12 14 15 17 18 19